import React from "react";
import { Ornament } from "./Ornament";
import { WHY_ME } from "../data/content";
import { User, Lightbulb, Gem, Sparkles, Globe } from "lucide-react";

const iconMap = {
  user: User,
  lightbulb: Lightbulb,
  gem: Gem,
  sparkles: Sparkles,
  globe: Globe,
};

export default function WhyMe() {
  return (
    <section
      id="why-me"
      className="relative bg-[var(--lu-cream)] py-24 lg:py-32 border-y border-[var(--lu-gold)]/30"
      data-testid="why-me-section"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 text-center">
        <p className="font-micro text-[10px] text-[var(--lu-gold-dark)]">Why Lumière</p>
        <h2 className="mt-4 font-serif text-4xl sm:text-5xl lg:text-6xl text-[var(--lu-black)]">Five reasons customers<span className="italic text-[var(--lu-gold-dark)]">they return</span>
        </h2>
        <Ornament className="mt-8" />

        <div className="mt-16 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-8">
          {WHY_ME.map((pillar, i) => {
            const Icon = iconMap[pillar.icon];
            return (
              <div
                key={pillar.name}
                className="flex flex-col items-center text-center group"
                data-testid={`pillar-${i}`}
              >
                <span className="w-20 h-20 flex items-center justify-center border border-[var(--lu-gold-dark)] rounded-full group-hover:bg-[var(--lu-gold)] transition-colors duration-500">
                  <Icon size={26} className="text-[var(--lu-gold-dark)] group-hover:text-[var(--lu-black)] transition-colors" />
                </span>
                <p className="mt-6 font-micro text-[11px] text-[var(--lu-black)] max-w-[140px]">
                  {pillar.name}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
